module.exports = __webpack_public_path__ + "img/finland-diabetes-mellitus-male.7bcab1af.png";